import { Attribute, SearchHandler, SearchResult } from '@/components/Form/AudienceTargeting/Audience/interfaces'
import fetch from '@/utilities/fetch'

// Theres a bunch of other attribute in this, but I don't really care too much about them
interface User {
  displayName: string
  email: string
  id: string
  name: { familyName: string; givenName: string }
  timezone: string
  userName: string
}

interface ApiResponse {
  itemsPerPage: number
  resources: User[]
  startIndex: number
  totalResults: number
}

const searchForUser = async (searchTerm: string, searchableAttributes: string[]): Promise<ApiResponse> => {
  const query = {
    attributes: searchableAttributes,
    count: 10,
    filter: searchableAttributes.map(attribute => `${attribute} co ${searchTerm}`).join(' or ')
  }
  return await fetch(
    '/organizations/:organizationId/users/search',
    { method: 'POST', body: { ...query, spaceId: ':spaceId' } },
    { service: 'tenant' }
  )
}

class UserSearch implements SearchHandler {
  private attributes: Attribute[]

  constructor(_attr: Attribute, aggregateAttributes: Attribute[]) {
    this.attributes = aggregateAttributes
  }

  async search(searchTerm: string): Promise<SearchResult[]> {
    const searchableAttributes = this.attributes.map(attr => attr.urn)
    const results = await searchForUser(searchTerm, searchableAttributes)
    return results.resources.map(result => ({
      id: result.id,
      count: 1,
      resourceType: 'User',
      term: result.displayName || result.email,
      subtitle: result.email,
      type: 'individual',
      termId: result.id
    }))
  }

  getAttribute(): Attribute {
    return {
      displayName: 'Individual',
      id: 'individual',
      type: 'string',
      scimAttributeName: 'individual',
      urn: 'id'
    }
  }

  getValue(searchResult: SearchResult) {
    return {
      value: `${searchResult.termId}`,
      displayValue: `${searchResult.term}`,
      subtitle: searchResult.subtitle || ''
    }
  }
}

export default UserSearch
